
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"15.167","y":"23.333","width":"2.667","height":"2.667","rx":".5","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.37 22.118c-.907-.454-1.643-.956-2.203-1.486l.933-.365-3.066-1.6-.4 2.8 1.2-.295c.748.832 1.767 1.552 2.94 2.139 1.913.956 4.352 1.625 7.06 1.893v-1.34c-2.516-.263-4.747-.888-6.463-1.746zm11.797 1.745v1.34c2.707-.267 5.147-.936 7.06-1.892 1.173-.587 2.192-1.307 2.94-2.139l1.2.295-.4-2.8-3.066 1.6.933.365c-.56.53-1.296 1.032-2.204 1.486-1.716.858-3.947 1.483-6.463 1.745z","fill":"currentColor"}})])
          )
        }
      }
    